import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AppActions from "../../actions";
import Header from "../../components/Header";
import { withRouter } from "react-router-dom";
import FormListItem from "../../components/FormListItem";
import { Grid } from "semantic-ui-react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import _ from "lodash";

class OutboxContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastRefresh: Date(Date.now()).toString(),
      width: 800,
      height: 182
    };
    this.refreshScreen = this.refreshScreen.bind(this);
  }

  handleBack() {
    return true;
  }

  refreshScreen() {
    if (this.props.isConnected) {
      this.setState({ lastRefresh: Date(Date.now()).toString() });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.lastRefresh !== nextState.lastRefresh) {
      const { actions } = this.props;

      actions.readDrafts();
    }
    return true;
  }

  componentWillMount() {
    const { actionQueue, storeId, test } = this.props;

    var forms = _.filter(actionQueue, {
      storeId: storeId,
      isDraft: false,
      test: test
    });

    if (forms.length === 0 && this.props.isConnected) {
    }
  }

  handleClick(form_id, form_title, icon_path, form_version, uuid) {
    var form = _.filter(this.props.actionQueue, {
      uuid: uuid,
      test: this.props.test
    });

    this.props.actions.cloneImages(uuid);
    this.props.actions.updateFormTitle(
      form_title,
      form_version,
      icon_path,
      form_id
    );
    let recovered = false;
    if (
      this.props.recovered_form.length !== 0 &&
      this.props.recovered_formId === form_id &&
      this.props.recovered_draft === true
    ) {
      recovered = true;
      this.props.actions.setWorkingDraft(this.props.recovered_form, "");
    } else {
      this.props.actions.setWorkingDraft(form[0].draft, uuid);
    }

    this.props.history.push(
      `/form/${form_id}/${
        form[0].uuid
      }/${recovered}/${form_title}/${form_version}/${
        form[0].result_id
      }/0/undefined/${true}`
    );
  }

  handleDeleteDraft(uuid) {
    const options = {
      title: "Confirm Delete",
      message: "Are you sure you want to delete this form?",
      buttons: [
        {
          label: "OK",
          onClick: () => this.props.actions.deleteDraft(uuid)
        },
        {
          label: "Cancel",
          onClick: () => {}
        }
      ]
    };

    confirmAlert(options);
  }

  getForms() {
    const { storeId, test } = this.props;

    var forms = _.filter(this.props.actionQueue, {
      storeId: storeId,
      isDraft: false,
      test: test
    });

    var formsOrdered = forms;
    var forms = [];

    formsOrdered.forEach((form, index) => {
      forms.push(
        <FormListItem
          container="Outbox"
          onDelete={this.handleDeleteDraft.bind(this)}
          onClick={this.handleClick.bind(this)}
          {...form}
          key={index}
        />
      );
    });

    if (forms.length === 0) {
      return <div></div>;
    }

    return (
      <div className="formSectionContainerX">
        <form className="ui formList">
          <Grid columns={6} doubling>
            <Grid.Row>{forms}</Grid.Row>
          </Grid>
        </form>
        <br />
        <br />
        <br />
      </div>
    );
  }

  render() {
    let y = this.state.height - 50 + "px";

    const { actions } = this.props;
    return (
      <div>
        <Header
          formTitle={"Outbox"}
          setSidebarVisibility={actions.setSidebarVisibility}
        ></Header>
        <div
          className="formsBackground"
          style={{ height: y, overflowY: "scroll" }}
        >
          {this.getForms()}
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  sessionId: state.informedWebApp.sessionId,
  deviceId: state.informedWebApp.deviceId,
  isLoading: state.informedWebApp.isLoading,
  storeId: state.informedWebApp.storeId,
  refresh: state.informedWebApp.refresh,
  isConnected: state.informedWebApp.isConnected,
  actionQueue: state.informedWebApp.actionQueue,
  recovered_form: state.forms.recovered_form,
  recovered_formId: state.forms.recovered_formId,
  recovered_draft: state.forms.recovered_draft,
  test:
    state.informedWebApp.api === "https://www.in-formed.co.uk/api.php"
      ? false
      : true,
  storeColour: state.informedWebApp.storeColour
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OutboxContainer)
);



// WEBPACK FOOTER //
// ./src/containers/OutboxContainer/index.js